module.exports = __webpack_public_path__ + "03_mid_yellow.b0b42aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/03_mid_yellow.png
// module id = B4oR
// module chunks = 0